import { Dispatch, SetStateAction, useEffect } from "react";
import { SegButton } from "../../../../SegUI/SegButton/SegButton";
import { SegInput } from "../../../../SegUI/SegInput/SegInput";
import { IPasos } from "../../../../../Pages/Prepaga/Individuo/Cotizador";
import { useNavigate, useParams } from "react-router-dom";
import { useForm, Controller, SubmitHandler } from "react-hook-form";
import { useCotizacionStore } from "../../../../../Services/Providers/CotizacionStore";
import { RazonSocial } from './RazonSocial';

type FormValues = {
  setEmail: string;
};

interface EmailProps {
  setSteps: Dispatch<SetStateAction<IPasos>>;
  emailValue: string | undefined;
}

export const Email = ({ setSteps, emailValue, ...rest }: EmailProps) => {
  const nav = useNavigate();
  const { compania } = useParams();
  const { cotizacionValues, setCotizacionValues } = useCotizacionStore();


  const { handleSubmit, control, setValue, setError, formState, trigger } =
    useForm<FormValues>();

  const onSubmit: SubmitHandler<FormValues> = (values: FormValues) => {
    const { setEmail } = values;
    setCotizacionValues({
      ...cotizacionValues,
      email: setEmail.toLowerCase(),
    });
    compania
      ? nav("/prepaga/corporativo/cotizacion/" + compania + "/telefono-celular")
      : nav("/prepaga/corporativo/cotizacion/telefono-celular");
  };

  // Obtén el valor del error desde la URL
  const urlParams = new URLSearchParams(window.location.search);
  const error = urlParams.get('error');



  useEffect(() => {
    if (error) {
      setError("setEmail", {
        type: 'custom',
        message: error,
      });
    } else {
      setValue("setEmail", emailValue ? emailValue : "");
      emailValue && trigger()
    }
  }, []);

  useEffect(() => {
    !cotizacionValues.razonSocial && (compania ? nav("/prepaga/corporativo/cotizacion/" + compania + "/razon-social") : nav("/prepaga/corporativo/cotizacion/razon-social"))
  }, [])

  return (
    <div className="mt-4 bg-gray-light text-center" {...rest}>
      <div className="frm01">
        <legend>¿Tu e-mail?</legend>

        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="mw-sm-450 m-auto d-flex justify-content-center">
            <Controller
              name="setEmail"
              control={control}
              rules={{
                validate: {
                  required: (value) => (!!value || "Ingresá el email"),
                  pattern: (value) =>
                    /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(
                      value
                    ) || "Email inválido",
                },
              }}
              render={({ field, fieldState }) => (
                <SegInput

                  className="mt-3"
                  label=""
                  name="setEmail"
                  type="text"
                  width={92}
                  placeHolder="Ej: nombre@dominio.com.ar"
                  onChange={(e) => {
                    field.onChange(e);
                    setValue("setEmail", e.target.value); // Actualiza el valor en React Hook Form
                    trigger("setEmail");
                  }}
                  value={field.value}
                  autoFocus={true}
                  leyendaError={fieldState?.error?.message}
                  borderColor={`${formState.errors.setEmail
                    ? "var(--bs-form-invalid-border-color)"
                    : ""
                    }`}
                  focusBorderColor={`${formState.errors.setEmail
                    ? "var(--bs-form-invalid-border-color)"
                    : "#2c7dfd"
                    }`}
                />
              )}
            />
          </div>
          <div className="form-buttons">
            <SegButton
              label="Continuar"
              type="submit"
              className="btn btn-primary"
              disabled={
                !formState.isValid // Verifica si el formulario es válido
              }
            />
          </div>
        </form>
      </div>
    </div>
  );
};
